import React from 'react';
import tw from 'twin.macro';
import { Link } from 'gatsby';

import { Heading, Subtitle, Button, Container } from '../atoms';
import SanityImage from '../global/SanityImage';

const ServiceOption = (props) => {
  const { serviceOption = [] } = props;
  return (
    <Container tw="bg-slate">
      <div tw="bg-white">
        <div tw="grid grid-cols-1 md:grid-cols-3 gap-4 px-10 md:px-20 py-8 shadow-lg">
          {serviceOption.map((item) => (
            <div tw="p-10" key={item._key}>
              <div
                css={[
                  tw`max-w-sm mx-auto bg-white flex items-center`,
                  !item.title ? tw` justify-center` : '',
                ]}
              >
                <div tw="flex-shrink">
                  {item.icon && item.icon.asset && (
                    <SanityImage
                      gatsbyImageId={item.icon.asset.id}
                      alt={item.title}
                      width={60}
                      height={60}
                      objectFit="contain"
                      tw="h-16 w-16"
                    />
                  )}
                </div>

                {item.title && (
                  <Heading
                    variant="base"
                    css={[
                      tw`selection:bg-blue-600 selection:text-white `,
                      !item.title ? tw`text-center` : tw`ml-5`,
                    ]}
                  >
                    {item.title}
                  </Heading>
                )}
              </div>
              <div tw="pt-6 space-y-4">
                <Subtitle
                  css={[
                    tw`selection:bg-blue-600 selection:text-white `,
                    !item.title ? tw`text-center` : '',
                  ]}
                >
                  {item.description}
                </Subtitle>
                {item.link && (
                  <Link to={`${item.link}`}>
                    <Button width="fullWidth">LEARN MORE</Button>
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default ServiceOption;
